/** HSlider registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseHSlider } from './parser';
const hSliderRegistration = {
    typeName: 'HSlider',
    parser: parseHSlider,
};
nodeRegistry.register(hSliderRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map